import { z } from 'zod';
import { hhmm, isoDate, timeZone, uuid } from './common';

export const MAX_QUESTIONS = 10;
export const MAX_HISTORY_CHARS = 50_000;

/** One wizard step's worth of changes; every field optional (INT-01, INT-02). */
export const intakePatch = z
  .object({
    caseTypeId: uuid.nullable(),
    poolId: uuid,
    demographicsVolunteered: z.boolean().nullable(),
    gender: z.enum(['female', 'male', 'other']).nullable(),
    dateOfBirth: isoDate.nullable(),
    history: z.string().max(MAX_HISTORY_CHARS),
    questions: z.array(z.string().trim().min(1).max(1000)).max(MAX_QUESTIONS),
    intakeStep: z.number().int().min(1).max(7),
  })
  .partial()
  .strict();
export type IntakePatch = z.infer<typeof intakePatch>;

/** Times the patient offers, as wall-clock slots in their zone; the server converts (SCH-01, SCH-02). */
export const availabilityPut = z.object({
  tz: timeZone,
  slots: z.array(z.object({ date: isoDate, time: hhmm })).max(200),
});
export type AvailabilityPut = z.infer<typeof availabilityPut>;

export const submitCase = z.object({ termsVersion: z.string().min(1).max(20), accepted: z.literal(true) });

export const startCase = z.object({ device: z.enum(['phone', 'tablet', 'computer']).optional() });

export const createAttachment = z.object({
  filename: z.string().trim().min(1).max(200),
  sizeBytes: z.number().int().positive(),
  contentType: z.string().min(1).max(100),
});

export const describeAttachment = z.object({ description: z.string().trim().min(1).max(300) });

export const assistantResolve = z.object({ outcome: z.enum(['accepted', 'edited', 'skipped']) });

/** INT-12: a navigator starts a case for a patient who called. */
export const staffStartCase = z.object({ patientId: uuid });

export const externalAttachment = createAttachment.extend({
  description: z.string().trim().min(1).max(300),
  externalSource: z.string().trim().min(1).max(200),
});
